"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Make these at least a little terse, there will be a lot of them...
var SERVER_SYNC_STATE = exports.SERVER_SYNC_STATE = "SERVER_SYNC_STATE";
var SERVER_SEND_ACTION = exports.SERVER_SEND_ACTION = "SERVER_SEND_ACTION";
var SERVER_DISCONNECT = exports.SERVER_DISCONNECT = "SERVER_DISCONNECT";
var SERVER_ERROR = exports.SERVER_ERROR = "SERVER_ERROR";
var SERVER_ACKNOWLEDGE_NOTIFICATION = exports.SERVER_ACKNOWLEDGE_NOTIFICATION = "SERVER_ACKNOWLEDGE_NOTIFICATION";
var SERVER_UPDATE = exports.SERVER_UPDATE = "SERVER_UPDATE";
//# sourceMappingURL=serverConstants.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/server/serverConstants.js
// module id = 101
// module chunks = 0